module.exports = "<div #wrapper\r\n     class=\"overlay-content tooltip-wrapper position-{{position}}\"\r\n     [style.top]=\"coordinates.top\"\r\n     [style.right]=\"coordinates.right\"\r\n     [style.bottom]=\"coordinates.bottom\"\r\n     [style.left]=\"coordinates.left\">\r\n    <div class=\"popup-content\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/core/components/tooltip/tooltip.component.html
// module id = ./client-src/app/core/components/tooltip/tooltip.component.html
// module chunks = main